
import PostDataComplex from '../../services/PostDataComplex'
import resizeFile from './resizeFile'

import delay from '../../utils/functions/delay'

  // 
  // 
  // 

    
  let counter = 0;
  let res;

  async function saveImagesToServer(image){
    const imageMini = await resizeFile(image);
    console.log('imageMini->');
    console.log(imageMini);

    console.log(`image:->`);
    console.log(image);

    const img = {img_name: image.name};
    console.log(`img:->`);
    console.log(img);

    // const aImages = images ? images.slice(0) : [];
    // aImages.unshift(img);
    // console.log(`aImages:->`);
    // console.log(aImages);
    // setImages(aImages);

    // get data from sessionStorage
    const token = (JSON.parse(sessionStorage.userData)).user.token;
    console.log(`token: ${token}`);
    const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
    console.log(`user: ${user}`);
    
    // prepare data to send
    const imageData = {
      user_name: user,
      user_token: token,
      // nameImage: image.name,
      active: 'active',
      lastModified: image.lastModified,
      lastModifiedDate: image.lastModifiedDate,
      sizeImage: image.size,
      typeImage: image.type,
      image: image,
      imageMini: imageMini,
    }

    // setToggleMessageModal(true);
    // setMessage(`Please wait while uploading image ${counter}`);
    
    console.log(`imageData: ${JSON.stringify(imageData)}`);
    
    let message = ''
    let errorMessage = ''

    // const aImages = images ? images.slice(0) : [];

    let saveImageId = ''

    try {

      await PostDataComplex('images_manager', 'POST', 'saveImage', imageData)
        // PostData('POST', 'saveImage', imageData)
        .then((response) => {
          console.log('saveImage response.data:->');
          console.log(response.data);
          
          const saveImageData = response.data.feedBack.saveImageData;
          console.log('saveImageData->');
          console.log(saveImageData);

          saveImageId = saveImageData.saveImageResult.imageid;
          console.log('saveImageId->');
          console.log(saveImageId);
          
          // setToggleMessageModal(true);

          // setErrorMessage(null);
          // setMessage(null);

        

          if(saveImageData.saveImageResult.imageSaved || saveImageData.saveImageResult.error) {
            if(saveImageData.saveImageResult.imageSaved) {
              console.log('Images uploaded succesfully!!!');

              // setMessage('image uploaded succesfully!!!');
              message = 'image uploaded succesfully!!!';

              // aImages.unshift(img);
              // console.log(`aImages:->`);
              // console.log(aImages);
              // setImages(aImages);
              // setImages([...imagesData.images].reverse());
              
            } else {
              console.log('Images upload error!!!');
              console.log(saveImageData.saveImageResult.error);
              // setErrorMessage(saveImageData.saveImageResult.error);
              errorMessage = saveImageData.saveImageResult.error;
              
            } 
            
          } else if(saveImageData.imageMini) {
            if(saveImageData.imageMini.errorMessage) {
              console.log(saveImageData.imageMini.errorMessage.error);
              // setErrorMessage(saveImageData.imageMini.errorMessage.error);
              errorMessage = saveImageData.imageMini.errorMessage.error;
            }
          } else{
                console.log(saveImageData.image.errorMessage.error);
                // setErrorMessage(saveImageData.image.errorMessage.error);
                errorMessage = saveImageData.image.errorMessage.error;
              }
          }
        )
    } catch (err) {
      console.log(`err ${err}`);
      // setErrorMessage('error uploading image');
      errorMessage = 'error uploading image';
    }
  

    console.log(``);
    console.log(`----------------------------------------------------`);
    console.log(``);

    await delay(1000);

    // setToggleMessageModal(false);

    console.log(`message: ${message}`)
    console.log(`errorMessage: ${errorMessage}`)

    return [counter++, message, errorMessage, saveImageId];
  }

  // 
  // method recursive is not used anymore
  // regular method is on momentarily
  // 
  async function recursive(images){
    console.log(`counter: ${counter}`)
    console.log(`images[${counter}]: ${images[counter].name}`)
   
    res = await saveImagesToServer(images[counter]);
    console.log(`called saveImagesToServer with return value = ${res[0]}`);

    console.log(`res[0] = ${res[0]}`);
    console.log(`res[1] = ${res[1]}`);
    console.log(`res[2] = ${res[2]}`);

    const aImages = images ? images.slice(0) : [];
    const img = {img_name: images[counter].name}
    aImages.unshift(img);
    console.log(`aImages:->`);
    console.log(aImages);

    if(res[0] < images.length-1){
      console.log(`res[0]: ${res[0]}`)
      return await recursive(images);
    }
    return aImages;
  }



  export default saveImagesToServer
